import { io } from 'socket.io-client'

const { VITE_APP_SERVER } = import.meta.env
let sockets = []

async function ioInit(options = { auth: undefined }) {
    return new Promise(resolve => {
        const { auth } = options
        const socketIndex = auth?.token ? 1 : 0

        if (sockets[socketIndex]) {
            resolve(sockets[socketIndex])
            return
        }

        sockets[socketIndex] = io(VITE_APP_SERVER + '/banc', {
            transports: ['websocket'],
            auth,
        })

        sockets[socketIndex].on('connect', () => {
            console.info(`connected to ${sockets[socketIndex].nsp} namespace`)
        }).on('disconnect', reason => {
            console.info(`disconnected from ${sockets[socketIndex].nsp} namespace: `, reason)
        }).on('error', error => {
            error
        })

        resolve(sockets[socketIndex])
    })
}
const sio = ioInit()

export {
    sio,
    sockets,
    ioInit
}
